import { BaseView, Container, delayedCall, dispatcher, killDelayedCall, ingenuity, SpineBase, clone, IObject } from "@quest/base-core";
import { ISpineData } from "@quest/pixi-bridge";
import { SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist/Game/BehaviorConstants/SlotEventDispatchersBehavior";
import { FreeGameModel, Reel, SlotEventConstants, SymbolBase, FreeGameView } from "@quest/slot-core";

import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class FgCascadingReelPanelController {
  private view: any;
  private cascadeView: BaseView;
  private burstSpineArray: SpineBase[] = [];
  private cascadeSymArray: SymbolBase[] = [];
  protected model: FreeGameModel;

  constructor(view: FreeGameView, cascadeView: BaseView, model: any) {
    this.view = view;
    this.cascadeView = cascadeView;
    this.model = model;
    this.subscriveEvents();
  }

  /**
   * This method subscribe the  events of this class
   */
  private subscriveEvents(): void {
    this.unSubscriveEvents();
    dispatcher.on(eventDispatchers.FG_BURST_SYMBOLS, this.fgBurstSymbolsStarted, this);
    dispatcher.on(eventDispatchers.FG_BURST_SYMBOLS_DESTROY, this.fgResetBurstSymbols, this);
  }

  /**
   * This method un subscribe the  events of this class
   */
  private unSubscriveEvents(): void {
    dispatcher.off(eventDispatchers.FG_BURST_SYMBOLS, this.fgBurstSymbolsStarted, this);
    dispatcher.off(eventDispatchers.FG_BURST_SYMBOLS_DESTROY, this.fgResetBurstSymbols, this);
  }

  /**
   * Add to start burst symbol animation during fg cascade
   */
  private fgBurstSymbolsStarted(): void {
    ((ingenuity.parserModel as GameParserModel).getCascadeNumber() <= gameConstants.MAX_PROGRESS_COUNT) && dispatcher.fireEvent(eventDispatchers.ON_CASCADE_UPDATE_FS_BAR_RETRIGGER, (ingenuity.parserModel as GameParserModel).getCascadeNumber());
    this.fgBurstSymbols();
  }

  /**
   * This method start the burst animation of the symbols
   * @cascadeOffsets win offsets of burst symbols
   */
  private fgBurstSymbols(): void {
    const cascadeOffsets: number[][][] = (ingenuity.parserModel as GameParserModel).getCascadeOffsets();
    this.playAllBurstAnimByOffsets(cascadeOffsets[0]);
    dispatcher.fireEvent(eventDispatchers.ADD_STICKY_FRMAES,cascadeOffsets[0]);
    this.playSymbolExplodeSound()
  }

  /**
     * This method plays the symbol explode sound fx.
     */
    private playSymbolExplodeSound(): void {
      const soundObj: IObject = { id: SoundConstantGame.SYMBOL_EXPLODE_SOUND, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD };
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, soundObj);
    }

  /**
   * This method returns all burst animation spine
   * @param offsets win offsets
   */
  private playAllBurstAnimByOffsets(offsets: number[][]): void {
    dispatcher.fireEvent(SlotEventConstants.FG_HIDE_ALL_PAYLINE_WINBOX);
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
    //dispatcher.fireEvent(eventDispatchers.HIDE_ZEUS_STACK_SYMBOL_WIN_ANIMATION);
    let newSpine: SpineBase;
    this.convertStackInIndividualSymbol(offsets);
    offsets.forEach((pos: number[]) => {
      const reelId: number = pos[0];
      const symId: number = pos[1];
      let reel: Reel = this.view.getReelView().getReels()[reelId];
      let sym: SymbolBase = this.view.getReelView().getSymbolByPos(reelId, symId);
      this.cascadeSymArray.push(sym);
      newSpine = this.getSpineJsonAndClone();
      newSpine.x = reel.x;
      newSpine.y = sym.y;
      let newContainer: Container = this.cascadeView.getContainerByID(gameConstants.CASCADE_REEL_CONTAINER_ID + String(reelId));
      newContainer.addChild(newSpine);
      newSpine.playAnim(gameConstants.CASCADE_SPINE_STRING_ID);
      delayedCall(
        gameConstants.HIDE_SYMBOLS_ON_BURST_ANIMATION_PLAY + reelId + symId,
        gameConstants.TIMER_200,
        () => {
          killDelayedCall(gameConstants.HIDE_SYMBOLS_ON_BURST_ANIMATION_PLAY + reelId + symId);
          sym.getStatic().visible = false;
        },
        this
      );
      this.burstSpineArray.push(newSpine);
    }, this);

    delayedCall(gameConstants.START_REEL_DROP_ON_BURST_ANIMATION_PLAY, gameConstants.TIMER_200, () => {
      killDelayedCall(gameConstants.START_REEL_DROP_ON_BURST_ANIMATION_PLAY);
      this.dissolveSymbolPositions();
    });
  }

  /**
   * This method destroys the burst animation spine on next spin call
   */
  private convertStackInIndividualSymbol(casCadePosition: number[][]): void {
    let reelGrid: number[][] = clone((ingenuity.parserModel as GameParserModel).getBaseGameGridForStack());
    let reelGridCol: number[] = [];
    casCadePosition.forEach((pos: number[]) => {
      if (reelGrid[pos[0]][pos[1]] === gameConstants.ZEUS_STACK_CUSTOM_SYMBOL_ID) {
        reelGridCol.push(pos[0]);
        reelGrid = this.updateValueInGrid(pos[0], pos[1], reelGrid);
      } else if (reelGrid[pos[0]][pos[1]] === gameConstants.TRANSPARENT_SYMBOL_ID) {
        for (let i = pos[1] - 1; i >= 0; i--) {
          if (reelGrid[pos[0]][i] === gameConstants.ZEUS_STACK_CUSTOM_SYMBOL_ID) {
            reelGridCol.push(pos[0]);
            reelGrid = this.updateValueInGrid(pos[0], i, reelGrid);
            break;
          }
        }
      }
    }, this);
    this.view.getReelView().showStaticGrid(reelGrid);
  }

  /**
   * Add to convert stack in individual symbol in grid
   */
  private updateValueInGrid(col: number, row: number, reelGrid: number[][]): number[][] {
    reelGrid[col][row] = gameConstants.ZEUS_SYMBOL_GAME;
    reelGrid[col][row + 1] && (reelGrid[col][row + 1] = gameConstants.ZEUS_SYMBOL_GAME);
    reelGrid[col][row + 2] && (reelGrid[col][row + 2] = gameConstants.ZEUS_SYMBOL_GAME);
    return reelGrid;
  }

  /**
   * This method is use to burst symbol
   */
  private dissolveSymbolPositions(): void {
    for (let reelId = 0; reelId < ingenuity.configData.numberOfReel; reelId++) {
      this.view.getReelView().children[reelId].dissolveSymbolPositions(reelId);
    }
  }

  /**
   * This method creates new spine via cloning
   * @returns return the spine
   */
  private getSpineJsonAndClone(): SpineBase {
    let cascadeEffect: ISpineData = this.cascadeView.json[gameConstants.CASCADE_SPINE_STRING_ID];
    let cascadeEffectAnim: SpineBase = this.view.createSpine(cascadeEffect);
    cascadeEffectAnim.visible = true;
    return cascadeEffectAnim;
  }

  /**
   * This method destroys the burst animation spine on next spin call
   */
  private fgResetBurstSymbols(): void {
    this.burstSpineArray.forEach((spine: SpineBase) => {
      spine.destroy();
    }, this);
    this.burstSpineArray = [];
    const allComponents: any = this.view.getAllcomponents();
    delete allComponents["cascade_effect"];
  }
}
